"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CentralMidfielderRoleBonuses = exports.CentralMidfielderExpandedRoles = void 0;
// centralMidfielderRoles.ts
const playerBonuses_1 = require("../playerBonuses"); // Added import
const playerTraits_1 = require("../playerTraits");
const rarity_1 = require("../rarity");
const zones_1 = require("../zones");
const baseRoles_1 = require("./baseRoles");
var CentralMidfielderExpandedRoles;
(function (CentralMidfielderExpandedRoles) {
    // --- Uncommon --- GENERIC (Consistent with other positions)
    CentralMidfielderExpandedRoles["RAPID_CENTRAL_MIDFIELDER"] = "RAPID_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["POWERFUL_CENTRAL_MIDFIELDER"] = "POWERFUL_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["TIRELESS_CENTRAL_MIDFIELDER"] = "TIRELESS_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["DETERMINED_CENTRAL_MIDFIELDER"] = "DETERMINED_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["HEROIC_CENTRAL_MIDFIELDER"] = "HEROIC_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["ECCENTRIC_CENTRAL_MIDFIELDER"] = "ECCENTRIC_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["RELIABLE_CENTRAL_MIDFIELDER"] = "RELIABLE_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["LUCKY_CENTRAL_MIDFIELDER"] = "LUCKY_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["TENACIOUS_CENTRAL_MIDFIELDER"] = "TENACIOUS_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["INSPIRATIONAL_CENTRAL_MIDFIELDER"] = "INSPIRATIONAL_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["DOMINANT_CENTRAL_MIDFIELDER"] = "DOMINANT_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["IMPACT_CENTRAL_MIDFIELDER"] = "IMPACT_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["PRESSING_CENTRAL_MIDFIELDER"] = "PRESSING_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["STUBBORN_CENTRAL_MIDFIELDER"] = "STUBBORN_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["VOCAL_CENTRAL_MIDFIELDER"] = "VOCAL_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["EXPERIENCED_CENTRAL_MIDFIELDER"] = "EXPERIENCED_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["FIREY_CENTRAL_MIDFIELDER"] = "FIREY_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["VERSATILE_CENTRAL_MIDFIELDER"] = "VERSATILE_CENTRAL_MIDFIELDER";
    // --- Uncommon --- CM SPECIFIC / FUNCTIONAL
    CentralMidfielderExpandedRoles["BOX_TO_BOX_MIDFIELDER"] = "BOX_TO_BOX_MIDFIELDER";
    CentralMidfielderExpandedRoles["TIKI_TAKA_MIDFIELDER"] = "TIKI_TAKA_MIDFIELDER";
    CentralMidfielderExpandedRoles["PLAYMAKER"] = "PLAYMAKER";
    CentralMidfielderExpandedRoles["SHIELDING_MIDFIELDER"] = "SHIELDING_MIDFIELDER";
    CentralMidfielderExpandedRoles["STAR_CENTRAL_MIDFIELDER"] = "STAR_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["SILKY_CENTRAL_MIDFIELDER"] = "SILKY_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["LETHAL_CENTRAL_MIDFIELDER"] = "LETHAL_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["ROAMING_MIDFIELDER"] = "ROAMING_MIDFIELDER";
    CentralMidfielderExpandedRoles["ORCHESTRATING_MIDFIELDER"] = "ORCHESTRATING_MIDFIELDER";
    // --- Rare --- GENERIC COMBINATIONS (Two basic traits)
    CentralMidfielderExpandedRoles["ATHLETIC_CENTRAL_MIDFIELDER"] = "ATHLETIC_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["ENERGETIC_CENTRAL_MIDFIELDER"] = "ENERGETIC_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["VALIANT_CENTRAL_MIDFIELDER"] = "VALIANT_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["PLUCKY_CENTRAL_MIDFIELDER"] = "PLUCKY_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["ROBUST_MIDFIELDER"] = "ROBUST_MIDFIELDER";
    CentralMidfielderExpandedRoles["GEGENPRESSING_MIDFIELDER"] = "GEGENPRESSING_MIDFIELDER";
    CentralMidfielderExpandedRoles["COMMANDING_CENTRAL_MIDFIELDER"] = "COMMANDING_CENTRAL_MIDFIELDER";
    CentralMidfielderExpandedRoles["ROUSING_CENTRAL_MIDFIELDER"] = "ROUSING_CENTRAL_MIDFIELDER";
    // --- Rare --- ARCHETYPAL MIDFIELDERS
    CentralMidfielderExpandedRoles["COMPLETE_MIDFIELDER"] = "COMPLETE_MIDFIELDER";
    CentralMidfielderExpandedRoles["MEZZALA"] = "MEZZALA";
    CentralMidfielderExpandedRoles["MIDFIELD_GENERAL"] = "MIDFIELD_GENERAL";
    CentralMidfielderExpandedRoles["CAPTAIN_FANTASTIC"] = "CAPTAIN_FANTASTIC";
    CentralMidfielderExpandedRoles["CARRIER"] = "CARRIER";
    CentralMidfielderExpandedRoles["ENGINE"] = "ENGINE";
    CentralMidfielderExpandedRoles["CARRILERO"] = "CARRILERO";
    CentralMidfielderExpandedRoles["BALL_WINNING_MIDFIELDER"] = "BALL_WINNING_MIDFIELDER";
})(CentralMidfielderExpandedRoles || (exports.CentralMidfielderExpandedRoles = CentralMidfielderExpandedRoles = {}));
exports.CentralMidfielderRoleBonuses = {
    [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER]: {
        rarity: rarity_1.Rarity.COMMON,
        statBlock: {
            pass: playerBonuses_1.PlayerBonuses.MAIN_POSITION_ATTRIBUTE,
            intercept: playerBonuses_1.PlayerBonuses.SECOND_POSITION_ATTRIBUTE,
            run: playerBonuses_1.PlayerBonuses.THIRD_POSITION_ATTRIBUTE,
        },
        positionsEnabled: [zones_1.Zones.DEFENSE, zones_1.Zones.MIDFIELD, zones_1.Zones.ATTACK],
        playerTraits: [],
    },
    // --- Uncommon --- GENERIC ---
    [CentralMidfielderExpandedRoles.RAPID_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RAPID],
    },
    [CentralMidfielderExpandedRoles.POWERFUL_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Power for tackles/physicality
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.POWERFUL],
    },
    [CentralMidfielderExpandedRoles.TIRELESS_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Stamina for running
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAMINA],
    },
    [CentralMidfielderExpandedRoles.DETERMINED_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Determined interceptions/effort
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DETERMINED],
    },
    [CentralMidfielderExpandedRoles.HEROIC_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Heroic pass
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HERO],
    },
    [CentralMidfielderExpandedRoles.ECCENTRIC_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Flair for dribbling runs
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FLAIR],
    },
    [CentralMidfielderExpandedRoles.RELIABLE_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Reliable passing
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RELIABLE],
    },
    [CentralMidfielderExpandedRoles.LUCKY_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Lucky pass/interception
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    [CentralMidfielderExpandedRoles.TENACIOUS_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Tenacity in the tackle
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNDERDOG],
    },
    [CentralMidfielderExpandedRoles.INSPIRATIONAL_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Inspiring pass
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.INSPIRE],
    },
    [CentralMidfielderExpandedRoles.DOMINANT_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Dominating midfield space reading play
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DOMINANT],
    },
    [CentralMidfielderExpandedRoles.IMPACT_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Sub coming on to change game with passing
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SUPER_SUB],
    },
    [CentralMidfielderExpandedRoles.PRESSING_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Intercepting high up
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PRESSING], // Assuming PlayerTraits.PRESSING exists
    },
    [CentralMidfielderExpandedRoles.STUBBORN_CENTRAL_MIDFIELDER]: {
        // Added for WORKHORSE
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Stubborn, hard to beat
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNYIELDING],
    },
    [CentralMidfielderExpandedRoles.VOCAL_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Dictates tempo
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.ORGANISED],
    },
    [CentralMidfielderExpandedRoles.EXPERIENCED_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wise passing
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.WISE],
    },
    [CentralMidfielderExpandedRoles.FIREY_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.IGNITE],
    },
    [CentralMidfielderExpandedRoles.VERSATILE_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // 3rd position attribute is Run
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.VERSATILE],
    },
    // --- Uncommon --- CM SPECIFIC / FUNCTIONAL ---
    [CentralMidfielderExpandedRoles.BOX_TO_BOX_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Driving runs from deep
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.CHARGE],
    },
    [CentralMidfielderExpandedRoles.TIKI_TAKA_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.TIKI_TAKA],
    },
    [CentralMidfielderExpandedRoles.PLAYMAKER]: {
        // Using specific name user preferred
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PLAYMAKER],
    },
    [CentralMidfielderExpandedRoles.SHIELDING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Shielding space, intercepting
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHIELD],
    },
    [CentralMidfielderExpandedRoles.STAR_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Star midfielder orchestrating play
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAR],
    },
    [CentralMidfielderExpandedRoles.SILKY_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Silky touch for dribbling through midfield
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FIRST_TOUCH],
    },
    [CentralMidfielderExpandedRoles.LETHAL_CENTRAL_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Goal threat from midfield
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LETHAL],
    },
    [CentralMidfielderExpandedRoles.ROAMING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Movement into space
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HALF_SPACES],
    },
    [CentralMidfielderExpandedRoles.ORCHESTRATING_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.CENTRAL_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHORT_PASS],
    },
    // --- Rare --- GENERIC COMBINATIONS ---
    [CentralMidfielderExpandedRoles.ATHLETIC_CENTRAL_MIDFIELDER]: {
        parentRoles: [
            CentralMidfielderExpandedRoles.RAPID_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.POWERFUL_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.ENERGETIC_CENTRAL_MIDFIELDER]: {
        parentRoles: [
            CentralMidfielderExpandedRoles.RAPID_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.TIRELESS_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.VALIANT_CENTRAL_MIDFIELDER]: {
        parentRoles: [
            CentralMidfielderExpandedRoles.DETERMINED_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.HEROIC_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Valiant effort making a key pass
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.PLUCKY_CENTRAL_MIDFIELDER]: {
        parentRoles: [
            CentralMidfielderExpandedRoles.LUCKY_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.TENACIOUS_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Plucky tackling/effort
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.ROBUST_MIDFIELDER]: {
        parentRoles: [
            CentralMidfielderExpandedRoles.TENACIOUS_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.POWERFUL_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.GEGENPRESSING_MIDFIELDER]: {
        parentRoles: [
            CentralMidfielderExpandedRoles.PRESSING_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.ORCHESTRATING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Pressing leads to intercepts, short pass helps after winning ball
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.COMMANDING_CENTRAL_MIDFIELDER]: {
        parentRoles: [
            CentralMidfielderExpandedRoles.EXPERIENCED_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.VOCAL_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Dictates tempo
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.ROUSING_CENTRAL_MIDFIELDER]: {
        parentRoles: [
            CentralMidfielderExpandedRoles.INSPIRATIONAL_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.DETERMINED_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Inspiring teammates through control/passing
        positionsEnabled: [],
        playerTraits: [],
    },
    // --- Rare --- ARCHETYPAL MIDFIELDERS ---
    [CentralMidfielderExpandedRoles.COMPLETE_MIDFIELDER]: {
        // Box to Box (Charge) + Shielding Midfielder (Shield)
        parentRoles: [
            CentralMidfielderExpandedRoles.BOX_TO_BOX_MIDFIELDER,
            CentralMidfielderExpandedRoles.SHIELDING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // A balance of attributes, run covers ground
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.MEZZALA]: {
        // Playmaker + Roaming Midfielder (Half Spaces)
        parentRoles: [
            CentralMidfielderExpandedRoles.PLAYMAKER,
            CentralMidfielderExpandedRoles.ROAMING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Needs to run into attacking half-spaces
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.MIDFIELD_GENERAL]: {
        // Dominant CM + Inspirational CM
        parentRoles: [
            CentralMidfielderExpandedRoles.DOMINANT_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.INSPIRATIONAL_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Dominating and Inspiring through passing/control
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.CAPTAIN_FANTASTIC]: {
        // Heroic CM + Inspirational CM
        parentRoles: [
            CentralMidfielderExpandedRoles.HEROIC_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.INSPIRATIONAL_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Combination of heroic and inspiring passes
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.CARRIER]: {
        // Orchestrating Midfielder (Short Pass) + Tireless CM (Stamina)
        parentRoles: [
            CentralMidfielderExpandedRoles.ORCHESTRATING_MIDFIELDER,
            CentralMidfielderExpandedRoles.TIRELESS_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Stamina to carry the ball effectively
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.ENGINE]: {
        // Tireless CM (Stamina) + Determined CM
        parentRoles: [
            CentralMidfielderExpandedRoles.TIRELESS_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.DETERMINED_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Non-stop running engine
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.CARRILERO]: {
        // Orchestrating Midfielder (Short Pass) + Roaming Midfielder (Half Spaces)
        parentRoles: [
            CentralMidfielderExpandedRoles.ORCHESTRATING_MIDFIELDER,
            CentralMidfielderExpandedRoles.ROAMING_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Shuttling midfielder linking play
        positionsEnabled: [],
        playerTraits: [],
    },
    [CentralMidfielderExpandedRoles.BALL_WINNING_MIDFIELDER]: {
        // Tireless CM (Stamina) + Pressing CM
        parentRoles: [
            CentralMidfielderExpandedRoles.TIRELESS_CENTRAL_MIDFIELDER,
            CentralMidfielderExpandedRoles.PRESSING_CENTRAL_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Primary function is winning the ball
        positionsEnabled: [],
        playerTraits: [],
    },
};
